module.exports = require("@mui/material/CardMedia");